import { render, staticRenderFns } from "./OrderReturnProducts.vue?vue&type=template&id=c1da66d2"
import script from "./OrderReturnProducts.vue?vue&type=script&lang=js"
export * from "./OrderReturnProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports